import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { Container, Typography, CircularProgress, Button } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || 'https://peoplefortech.com/api/v1';
const BASE_PATH = '/peoplefortech/v2';

const AcceptBookingPage = () => {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!id || !token) {
      setStatus('error');
      setMessage('Enlace inválido');
      return;
    }
    fetch(`${API_URL}/bookings/${id}/accept?token=${encodeURIComponent(token)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
    })
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setStatus('success');
          setMessage('Cita confirmada. Se ha enviado un email al usuario.');
        } else {
          setStatus('error');
          setMessage(data.error || 'Error al confirmar');
        }
      })
      .catch(() => {
        setStatus('error');
        setMessage('Error de conexión');
      });
  }, [id, token]);

  return (
    <Container sx={{ py: 8, textAlign: 'center' }}>
      {status === 'loading' && <CircularProgress />}
      {status === 'success' && (
        <>
          <Typography variant="h5" color="success.main" gutterBottom>✓ {message}</Typography>
          <Button component={Link} to={BASE_PATH} variant="contained" sx={{ mt: 2 }}>
            Volver al inicio
          </Button>
        </>
      )}
      {status === 'error' && (
        <>
          <Typography variant="h5" color="error.main" gutterBottom>{message}</Typography>
          <Button component={Link} to={BASE_PATH} variant="outlined" sx={{ mt: 2 }}>
            Volver al inicio
          </Button>
        </>
      )}
    </Container>
  );
};

export default AcceptBookingPage;
